import { FC, memo, } from "react";
import { FONT_SIZE, NATURAL } from "@/theme";
import { Heading, PageHeader, PageWrapper, Typo } from "#/atoms";
import VideoPlayer from "@/components/organisms/VideoPlayer/VideoPlayer";
import { VideoShareProps } from "./VideoShare.interface";

const VideoShare: FC<VideoShareProps> = ({playerConfig}) => {

  return (
    <PageWrapper maxWidth="1024px" margin="auto">
      <PageHeader isResponsive={true} >
        <Heading scale="h1" fontColor={NATURAL.K} padding="10px">{playerConfig.title}</Heading>
        <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>{playerConfig.description}</Typo>
      </PageHeader>
      <VideoPlayer config={playerConfig} />
    </PageWrapper>
  );
};

export default memo(VideoShare);